import { render, staticRenderFns } from "./autocomplete-field.vue?vue&type=template&id=2b51e8fe"
import script from "./autocomplete-field.vue?vue&type=script&lang=js"
export * from "./autocomplete-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports